import script from "./AppContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContent.vue?vue&type=script&setup=true&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=26e3c854&lang=scss"

const __exports__ = script;

export default __exports__